import React, { useState, useEffect, useRef } from 'react';
import DatePicker from 'react-datepicker';
import { disableTyping } from 'utils';

/**
 * This is the old DatePicker time selection component to prevent bug with timepicker-ui on safari tablet/mobile
 */
const DatePickerHoursInput = ({
    names,
    values,
    disabled = { date: false, startTime: false, endTime: false },
    index,
    setFieldTouched,
    isNew = true,
    shouldOpenStartTime = false,
    onStartOpened,
    onTimeSelected,
}) => {
    const [isStartTime, setIsStartTime] = useState(false);
    const [isEndTime, setIsEndTime] = useState(false);

    const showStartTimeUnset = !isStartTime && isNew;
    const showEndTimeUnset = !isEndTime && isNew;

    const startPickerRef = useRef(null);

    useEffect(() => {
        if (shouldOpenStartTime && startPickerRef.current) {
            startPickerRef.current.setOpen(true);
            onStartOpened?.();
        }
    }, [shouldOpenStartTime]);

    return (
        <>
            <div className="time-container-row spacer">
                <span className="placeholder">{'Start *'}</span>
                <DatePicker
                    ref={startPickerRef}
                    selected={values.startTime}
                    onChange={value => {
                        const autoEndTime = new Date(value.getTime() + 60 * 60000);
                        setIsStartTime(true);
                        setIsEndTime(true);
                        onTimeSelected(value, names.startTime, 'start time', [
                            { fieldName: names.endTime, time: autoEndTime },
                        ]);
                    }}
                    onChangeRaw={disableTyping}
                    onBlur={() => {
                        setFieldTouched(`streams[${index}].startTime`, true, false);
                        setIsStartTime(true);
                    }}
                    showTimeSelect
                    showTimeSelectOnly
                    minTime={new Date().setHours(0, 0, 0, 0)}
                    maxTime={new Date().setHours(23, 45, 0, 0)}
                    timeIntervals={15}
                    timeCaption="Time"
                    dateFormat="h:mm aa"
                    required
                    disabled={disabled.startTime}
                    className={`spacer${showStartTimeUnset ? ' field-unset' : ''}`}
                />
            </div>
            <div className="time-container-row spacer">
                <span className="placeholder">{'Stop *'}</span>
                <DatePicker
                    selected={values.endTime}
                    onChange={value => {
                        setIsEndTime(true);
                        onTimeSelected(value, names.endTime, 'stop time');
                    }}
                    onChangeRaw={disableTyping}
                    onBlur={() => {
                        setFieldTouched(`streams[${index}].endTime`, true, false);
                        setIsEndTime(true);
                    }}
                    showTimeSelect
                    showTimeSelectOnly
                    minTime={values.startTime.getTime() + 15 * 60000}
                    maxTime={new Date().setHours(23, 45, 0, 0)}
                    timeIntervals={15}
                    timeCaption="Time"
                    dateFormat="h:mm aa"
                    required
                    disabled={disabled.endTime}
                    className={`spacer${showEndTimeUnset ? ' field-unset' : ''}`}
                />
            </div>
        </>
    );
};

export default DatePickerHoursInput;
